import { render } from "./test_card.vue?vue&type=template&id=0f00f54d&scoped=true"
import script from "./test_card.vue?vue&type=script&lang=js"
export * from "./test_card.vue?vue&type=script&lang=js"

import "./test_card.vue?vue&type=style&index=0&id=0f00f54d&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f00f54d"]])

export default __exports__